'use strict';

/**
 * A service providing actions when user verification is soon to expire or has expired.
 */
customerZone.service('VerificationService', ['Session', 'utils', function(Session, utils){

    var self = this;

    self.weeksBeforeExpiry = function(){
        return Session.profile().verifiedUntil.diff(moment(), 'weeks');
    };

    self.daysBeforeExpiry = function(){
        return Session.profile().verifiedUntil.diff(moment(), 'days');
    };

    /**
     * Checks if the verification is soon to be expired (within 11 weeks) and displays a message if it's the case.
     * If there is no expiry date or subscription is not prepaid, it exits.
     */
    self.checkVerificationStateExpiry = function(){

        if (!requiresVerification()) {
            utils.hideMessage('prepaid-verification');
            return;
        }

        var weeksLeft = self.weeksBeforeExpiry();

        if ( weeksLeft <= 11) {
            utils.showWarn(
                utils.format('your_verification_will_expire_in_{days}_days_you_can_renew_it_by_instructions',
                    {days: self.daysBeforeExpiry()}), 'prepaid-verification');
        }
        else
            utils.hideMessage('prepaid-verification');

    };

    function requiresVerification(){
        if (!Session.authenticated()) return false;
        if (!Session.profile().verifiedUntil) return false;
        return Session.subscribers().filter(function(c){ return c.isPrepaid(); }).length > 0;
    }
}]);
